module.exports = __webpack_public_path__ + "static/media/applepodcast.5891cc11.png";